import React from 'react';
import BioVitalDetailList from './BioVitalDetailList';

// Oxygen saturation detail list (reached from /user-bio-vitals Oxygen Count drill-down).
const OxygenDetailsList = () => (
  <BioVitalDetailList config={{
    title: 'Oxygen Saturation Details',
    routePath: '/oxygen-details',
    endpoint: '/admin/api/oxygen-details',
    valueLabel: 'Oxygen (%)',
    valueKey: 'oxygen',
    dateLabel: 'Datetime',
    dateKey: 'timestamp_utc',
    dateFmt: 'utc',
    totalLabel: 'Total Oxygen Saturation',
    breadcrumbType: 'Oxygen',
    exportName: 'oxygen-details.csv',
  }} />
);

export default OxygenDetailsList;
